import Share from './Share';
import { Builder } from '@builder.io/sdk';

const ShareConfig = {
  name: 'Share',
};

Builder.registerComponent(Share, ShareConfig);
